import { Logger } from 'simple-logging-lib';
import { targetElementRectsMessages } from '../communication/targetElementRects.messages';
import { LOGGER_NAME } from '../logging/setupLogger';
import { getSelectorsToElementRects } from '../utils/elementRectUtils';
export const onTargetElementRectsRequest = setTargetElementsToRects => (message, {
  reply
}) => {
  const logger = Logger.getLogger(LOGGER_NAME);
  const targetElementSelectors = Array.from(new Set(message.payload.targetElementSelectors));
  logger.debug('received selectors', targetElementSelectors);
  try {
    const targetElementsToRects = getSelectorsToElementRects(targetElementSelectors);
    const response = targetElementRectsMessages.sendTargetElementRects.create({
      targetElementsToRects
    });
    setTargetElementsToRects(targetElementsToRects);
    reply(response);
  } catch (error) {
    logger.error(error);
  }
};